// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulppxbi{gap:var(--ds-space-200,1pc)}._1bah1yb4{justify-content:space-between}\n._1bsb1osq{width:100%}\n._2lx21bp4{flex-direction:column}", ""]);
// Exports
module.exports = exports;
